<template>
  <div class="view-login" v-show="isLoadingFinish">
    <div class="page-content infinite-scroll" v-if="!isRegisterSuccess">
      <div class="page-bg">
        <div class="page-banner">
          <div
            class="swiper-container bannerSwiper swiper-container-horizontal"
            v-swiper:bannerSwiper="swiperOption"
          >
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                data-swiper-autoplay="8000"
                data-swiper-slide-index="0"
                style="width: 375px"
              >
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/mobile/recommend-banner1.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="rule">
          <a class="external" target="_blank" href="/recommendedActivities">
            <img
              src="https://resource.rcclchina.com.cn/userCenter/mb-icon.png"
              alt=""
            />
            <span>活动规则</span>
          </a>
        </div>
        <img
          class="home_logo"
          src="https://resource.rcclchina.com.cn/logo/MB/logoAnchorWhite.png"
          alt=""
        />
        <div class="yourfriend">您的好友{{ referralMobile }}</div>
        <img
          class="page-title-image"
          src="https://resource.rcclchina.com.cn/memberCenter/recommend-title3.png"
        />
        <div class="newText">新注册立即领取, 开启超凡游轮之旅!</div>
      </div>
      <div class="page-form">
        <div class="login-phone loginCon">
          <div class="item-content mt15">
            <div class="item-inner">
              <div
                class="item-input-title item-callingCode"
                style="width: auto; min-width: 90px"
              >
                <div class="callingCode">中国(+86)</div>
                <select class="callingCode-css callingCode-js">
                  <option selected="" value="中国(+86)">中国(+86)</option>
                </select>
              </div>
              <input
                id="phone"
                type="text"
                pattern="[0-9]*"
                name="Telephone"
                maxlength="11"
                placeholder="请输入手机号"
                @change="onMobileChange($event)"
              />
            </div>
          </div>

          <div class="item-tips" v-show="isRegisteredReward">
            此账号为已注册用户无法领取，<router-link
              class="external"
              to="/Orchard.Rccl.Users/Login/Login"
              >点击登录官网</router-link
            >
          </div>
          <!-- <div class="item-content mt15">
            <div class="item-inner">
              <span class="item-input-title">图形验证码</span>
              <div class="item-input">
                <input
                  id="picCode"
                  type="text"
                  name="PicCode"
                  v-model="picCode"
                />
                <img id="vcode" :src="this.picCodeImage" />
              </div>
            </div>
          </div> -->

          <div class="item-content mt15">
            <div class="item-inner">
              <span class="item-input-title">短信验证码</span>
              <div class="item-input">
                <input
                  v-model="smsCode"
                  id="validateCode"
                  type="text"
                  pattern="[0-9]*"
                  name="VerifyCode"
                  placeholder=""
                />
              </div>
            </div>
            <!-- @click="sendSmsCode()" -->
            <div
              class="send_btn"
              :class="{ disabled: smsCodeCountDown > 0 }"
              @click="onSmsClick"
            >
              {{ getSendSmsCodeText() }}
            </div>
          </div>

          <div class="item-content recommendedCode-js mt15">
            <div class="item-inner">
              <span class="item-input-title" style="min-width: 125px"
                >好友推荐码(选填)</span
              >
              <div class="item-input">
                <input
                  style="padding-left: 140px"
                  id="recommendedCode"
                  type="text"
                  pattern="[0-9]*"
                  name="RecommendedCode"
                  placeholder=""
                  v-model="recommendedCode"
                />
              </div>
            </div>
          </div>
          <div v-show="!isRegistered && isShowReward"
               class="login-txt login-title-tips isRegisterMember"
               :class="{ active: isCheckAll }"
               @click="handleCheckAll"
          >
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-selected.png" alt="" />
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-unselect.png" alt="" />
            <span class="login-sec">全选</span>
          </div>
          <div class="login-vip mt15"
               v-show="isRegistered && !isRegisteredReward && isShowReward">
            <div class="vip-title">加入会员尊享</div>
            <ul class="vip-content">
              <li>获得积分兑换精美礼品</li>
              <li>提前获取订票优惠及品牌资讯</li>
              <li>尊享更多会员线上线下活动通知</li>
            </ul>
          </div>
          <div v-show="(!isRegistered || !isRegisteredReward) && isShowReward"
               class="login-txt login-title-tips isRegisterMember"
               :class="{ active: wantToRegisterReward }"
               @click="handleCheckItem('wantToRegisterReward')"
          >
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-selected.png" alt="" />
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-unselect.png" alt="" />
            <span class="login-sec">我同意注册“皇家游享荟”会员（限中国大陆地区手机号），并接收品牌资讯及优惠信息，详见<router-link
                target="_blank"
                class="memberLink external"
                style="text-decoration: underline"
                to="/Rccl.UserCenter/RewardRule"
                >《项目细则》</router-link>
            </span>
          </div>
          <div v-show="!isRegistered"
               class="login-txt login-title-tips login-alink isAgreePrivacy"
               :class="{ active: wantToAgreePrivacy }"
               @click="handleCheckItem('wantToAgreePrivacy')">
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-selected.png" alt="" />
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-unselect.png" alt="" />
            <span>我已阅读并同意
              <router-link
                  target="_blank"
                  class="privacyLink external"
                  style="text-decoration: underline"
                  to="/Rccl.UserCenter/Privacy">《隐私政策》</router-link
              ><router-link
                  target="_blank"
                  class="privacyLink external"
                  style="text-decoration: underline"
                  to="/wz_index_law/index"
              >《用户协议》</router-link>
            </span>
          </div>
          <div v-show="isRegisteredReward && !isAgreeEmail  && isShowReward"
               class="login-txt login-title-tips isAgreePushMsg"
               :class="{ active: wantToAgreeEmail }"
               @click="handleCheckItem('wantToAgreeEmail')">
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-selected.png" alt="" />
            <img src="https://resource.rcclchina.com.cn/userCenter/mb-unselect.png" alt="" />
            <span class="login-sec">我想提前获取优惠信息，且同意接收皇家加勒比国际游轮品牌资讯</span>
          </div>

          <div class="content-block external loginButton mt15"
               id="loginPhoneSubmit"
              @click="onLoginClick">
            <img src="https://resource.rcclchina.com.cn/memberCenter/coupob.png" />
          </div>

          <div class="login-title-tips">
            如之前未使用手机注册过，则会自动为您创建新用户账号，方便您之后直接登录
          </div>
        </div>
        <img
          class="footLogo"
          src="https://resource.rcclchina.com.cn/logo/MB/logoBlue.png"
          alt=""
        />
        <div class="footTxt">
          皇家加勒比游轮船务（中国）有限公司在法律允许的范围内对本活动保留解释权
        </div>
      </div>
      <div class="verification-popup" v-show="isShowVerification">
        <div class="verification-bg"></div>
        <div class="verification-content">
          <div class="verification-title">
            安全验证
          </div>
          <div class="verification-main" id="verificationMain">

          </div>
        </div>
      </div>
    </div>

    <div
      class="page-content infinite-scroll page-success"
      :style="pageHeight"
      v-else
    >
      <img
        class="logo2"
        src="https://resource.rcclchina.com.cn/logo/MB/logoAnchorBlue.png"
        alt=""
      />
      <div class="s-txt">恭喜您获得</div>
      <div class="s-price">
        <img
          src="https://resource.rcclchina.com.cn/memberCenter/50OBC$%20.png"
        />
      </div>
      <div class="s-line"></div>
      <div class="s-text">
        优惠券已发放至您的个人中心，该优惠将适用于您在皇家加勒比官网和小程序的新增预订，用于抵扣您在出行中的部分船上消费，快来开启您的完美海上假期吧！
      </div>
      <div class="s-comm s-order" @click="goToLocalReward">查看更多福利</div>
      <div
        class="s-comm s-myCoupon"
        onclick="window.location.href='/Rccl.UserCenter/UserCoupon/UserCoupon?isExpired=1'"
      >
        查看我的优惠券
      </div>
    </div>

    <div id="captchaElement"></div>
    <button id="captchaTrigger" type="button" style="display:none"></button>

  </div>
</template>

<script>
import { directive } from "vue-awesome-swiper";
import { gioTracking } from "@/utilities/tools";
import api from "@/api";
const SCENE_ID = '5v4v21th';
export default {
  name: "RecommendLogin",
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOption: {
        autoplay: 5000,
        loop: true,
      },
      referralMobile: "",
      isLoadingFinish: false,
      callingCodes: [],
      isRegistered: false,
      isRegisteredReward: false,
      selectedCallingCode: {
        callingCode: "+86",
        countryName: "中国",
      },
      mobile: "",
      smsCode: "",
      smsCodeCountDown: 0,
      recommendedCode: "",
      wantToRegisterReward: false,
      wantToAgreeEmail: false,
      wantToAgreePrivacy: false,
      isRegisterSuccess: false,
      localRewardToken: "",
			isAllowLogin: true,
      afsType: "AliYunAfsNvc",
      isShowVerification: false,
      isShowReward: true,
      isCheckAll: false,
      captcha:null,
      loading: false,
      captchaVerifyParamLogin:'',
      captchaBizType: null  // 当前业务验证类型：login | sms
    };
  },
  async beforeMount() {
    this.$store.commit("SET_PAGE_TITLE", "");
    this.initPage();
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: true,
      isHideFooter: true,
    });
  },
  beforeDestroy() {
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: false,
    });
  },
  mounted() {
    this.initCaptcha();
  },
  methods: {
    handleCheckAll() {
      if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
        this.wantToAgreePrivacy = this.wantToAgreeEmail = this.isCheckAll =! this.isCheckAll;
      } else {
        this.wantToAgreePrivacy = this.wantToRegisterReward = this.isCheckAll =! this.isCheckAll;
      }
    },
    handleCheckItem (val) {
      switch (val) {
        case "wantToAgreePrivacy":
          this.wantToAgreePrivacy =! this.wantToAgreePrivacy;
          break;
        case "wantToRegisterReward":
          this.wantToRegisterReward =! this.wantToRegisterReward;
          break;
        case "wantToAgreeEmail":
          this.wantToAgreeEmail =! this.wantToAgreeEmail;
          break;
      }
      if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
        this.isCheckAll = this.wantToAgreePrivacy && this.wantToAgreeEmail;
      } else {
        this.isCheckAll = this.wantToAgreePrivacy && this.wantToRegisterReward;
      }
    },
    async initPage() {
      const referralCode = this.$router.currentRoute.query.referralCode;
      if (!referralCode || referralCode.length == 0) {
        location.href = "Login";
        return;
      }
      this.recommendedCode = referralCode;
      const { success, data } = await api.user.recommendLogin({
        referralCode,
      });
      if (!success || !data || !data.rcclCountries || !data.recommendedMobile) {
        location.href = "Login";
        return;
      }
      this.isLoadingFinish = true;
      this.callingCodes = data.rcclCountries;
      this.referralMobile = data.recommendedMobile;

    },
    onCallingCodeChange(e) {
      const value = e.target.value;
      const callingCode = this.callingCodes.filter(
        (r) => r.callingCode == value
      );
      if (callingCode && callingCode.length > 0) {
        this.selectedCallingCode = callingCode[0];
      }
    },
    onMobileChange(e) {
      const mobile = e.target.value;
      this.mobile = mobile;
      this.checkIsRegister(mobile);
    },
    async checkIsRegister(mobile) {
      if (mobile == null || mobile.length == 0) return
      const { success, data, errMsg } = await api.user.checkHasRegister(
        mobile,
        this.selectedCallingCode.callingCode
      );
      if (!success) console.error(errMsg);
      console.log(data)
      this.isRegistered = data.hasRegisterUser;
      this.isRegisteredReward = data.hasRegisterReward;
      this.isAgreeEmail = data.receiveMarketingFlag;
    },
    getInstance(instance) {
      this.captcha = instance
    },
    captchaFail() {
      this.loading = false
      this.captchaBizType = null
      this.isAllowLogin = false
    },

    onLoginClick() {
      if (this.loading) return
      this.captchaBizType = 'login'
      this.loading = true
      document.getElementById('captchaTrigger').click()
    },
    onSmsClick() {
      if (this.loading) return
      this.captchaBizType = 'sms'
      this.loading = true
      document.getElementById('captchaTrigger').click()
    },

    onCaptchaSuccess(captchaRes) {
      const biz = this.captchaBizType
      // 刷新
      this.captcha && this.captcha.refresh();
      
      this.$loading.hide();
      if (biz === 'login') {
        this.captchaSuccessLogin(captchaRes)
      } else if (biz === 'sms') {
        this.captchaSuccessSms(captchaRes)
      }
    },
    async captchaSuccessSms(captchaVerifyParam) {
      try {
        this.isAllowLogin = true;
        this.$loading.show();
        const request = this.getSmsRequest("AliYunAfsNc", captchaVerifyParam);
        await this.sendSmsApi(request);
      } finally {
        this.resetCaptcha()
      }
    },
    resetCaptcha() {
      if (this.captcha && typeof this.captcha.refresh === 'function') {
        this.captcha.refresh()
      }
      this.captchaBizType = null
      this.loading = false
      this.isAllowLogin = false
    },
    async captchaSuccessLogin(captchaVerifyParam) {
      try {
        this.isAllowLogin = true;
        this.captchaVerifyParamLogin = captchaVerifyParam
        await this.login();
      } finally {
        this.resetCaptcha()
      }
    },
    // 验证码初始化
    initCaptcha () {
			if (!window.initAliyunCaptcha) return
      window.initAliyunCaptcha({
        SceneId: SCENE_ID,
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: "popup",
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: "#captchaElement",
        // 触发验证码弹窗或无痕验证的元素
        button: '#captchaTrigger',
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
          width: 360,
          height: 40,
        },
        // 验证码验证通过回调函数
        success: this.onCaptchaSuccess,
        // 验证码验证不通过回调函数
        fail: this.captchaFail,
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: (instance) => {
          this.captcha = instance
        }
      });
		},
    async sendSmsCode() {
      if (this.smsCodeCountDown > 0 || !this.isAllowLogin) {
        return;
      }

			// 人机验证
      if (!window.nvc) return;
			this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
				// 无痕验证获取nvc data，用无痕验证模式调用发送短信接口
				const request = this.getSmsRequest("AliYunAfsNvc", nvcVal);
				await this.sendSmsApi(request);
			});
    },
		getSmsRequest (codeType, codeValue) {
			let callingCode = this.selectedCallingCode.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }
			const request = {
        phone: this.mobile,
        callingCode: callingCode,
        sessionKey: this.sessionKey,
				codeType: codeType,
				codeValue: codeValue,
        isPc:false,
        sceneId: SCENE_ID,
				captchaVerifyParam: codeValue,
      };
			return request;
		},
		// 无痕验证模式发送短信失败处理方法
		afsFailureHandler(code) {
			// 行为可疑，进入二次滑动验证
			if (code == 'NvcNc') {
				const ncoption = {
					renderTo: "#verificationMain",
				}
				let childNodes = document.getElementById('verificationMain').childNodes;
				for (let i = 0; i < childNodes.length; i++) {
					let childNode = childNodes[i];
					childNode.parentElement.removeChild(childNode);
				}
				// 唤醒二次验证（滑动验证码）
				this.isShowVerification = true;
        this.$nextTick(()=> {
          window.nvc.getNC(ncoption);
        })
			} else if (code == 'Block') {
				// 返回block，禁止发送短信
				this.isAllowLogin = false
				this.$alert.show(
          "网络错误，请刷新页面重试。"
        );
			}
		},
    async sendSmsApi(request) {
			if (!this.isAllowLogin) return;
      const { success, data, errMsg } = await api.user.smsCodeLogin(request);
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
				if (errMsg == 'NvcNc' || errMsg == 'Block') {
					// this.afsFailureHandler(errMsg)
         
				} else {
					this.$alert.show(errMsg);
				}
        return;
      } else {
				if (data && data.sessionKey) {
					this.$store.commit("SET_SESSION_KEY", data.sessionKey);
				}
        this.isShowVerification = false
        this.$alert.show(
          "短信发送成功！若您没有收到短信验证，请一分钟后重新发送。"
        );
      }
      this.smsCodeCountDown = 60;
      const self = this;
      let countDown = setInterval(() => {
        if (self.smsCodeCountDown == 0) {
          clearInterval(countDown);
        } else {
          self.smsCodeCountDown--;
        }
      }, 1000);
    },
    async login() {
      if (this.isRegisteredReward) {
        this.$alert.show(
          '此账号为已注册用户无法领取，<a class="external" href="/Orchard.Rccl.Users/Login/Login">点击登录官网</a>'
        );
        return;
      }

      if (!this.isRegistered && !this.wantToAgreePrivacy) {
        this.$alert.show("请勾选隐私政策");
        return;
      }

      if (!this.wantToRegisterReward) {
        this.$alert.show("领券前，请完成勾选");
        return;
      }

      if (this.mobile == null || this.mobile.length == 0) {
        this.$alert.show("请输入手机号");
        return;
      } else if (this.smsCode == "") {
        this.$alert.show("请输入短信验证码");
        return;
      }

      this.$loading.show();
      let callingCode = this.selectedCallingCode.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }

      let isAgreeEmail;
      if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
        isAgreeEmail = this.wantToAgreeEmail && this.isShowReward;
      } else {
        isAgreeEmail = this.wantToRegisterReward && this.isShowReward;
      }

      const { success, data, errMsg } = await api.user.login({
        mobile: this.mobile,
        smsCode: this.smsCode,
        callingCode: callingCode,
        sessionKey: this.sessionKey,
        recommendedCode: this.recommendedCode,
        source: "mobile",
        isAgreeEmail: isAgreeEmail,
        isRegisterMember: isAgreeEmail,
        openId: this.$store.state.user.wechatOpenId,
        isCheckPrivacy: this.wantToAgreePrivacy,
        sceneId: SCENE_ID,
        captchaVerifyParam: this.captchaVerifyParamLogin,
      });
      if (!success) {
        console.error(errMsg);
        this.$alert.show(errMsg);
      } else if (data && data.accessToken) {
        this.$store.dispatch("SET_USER_TOKEN", data.accessToken);
        this.loginSuccessHandler(data);
      }
      this.$loading.hide();
    },
    async loginSuccessHandler(response) {
      try {
        let hmsrTxt = this.$store.state.page.trackingCode.hmsr + "";
        if (hmsrTxt == "") {
          hmsrTxt = "不适用";
        }
        if (window.gio) {
          window.gio("page.set", "LoginStatus", hmsrTxt + response.isNewUser);
          window.gio("track", "LoginStatusTracking", {
            LoginStatusTracking: hmsrTxt + response.isNewUser,
            IsNewLocalReward: hmsrTxt + response.isRegisterMember,
            IsMarketable: "1",
          });
          window.gio("track", "NewLoginTracking", {
            NewLoginTracking: response.isNewUser,
          });
        }

        try {
          let eventName = response.isNewUser ? 'evt_Register': 'evt_Login';
          let isAll = 'nil';
          if(this.isCheckAll) {
            isAll = this.isCheckAll ? '1' : '0';
          }
          let isNewLRMkt = 'nil'
          if (response.isNewLocalReward) {
            isNewLRMkt = this.wantToRegisterReward ? '1': '0';
          }
          // let isMkt = "nil";
          // if (!this.isAgreeEmail) {
          //   isMkt = this.wantToAgreeEmail ? "1": "0";
          // }
          let sUrl = "nil"
          if (this.$route.query.returnUrl && this.$route.query.returnUrl.length > 0) {
            sUrl = decodeURIComponent(this.$route.query.returnUrl)
          }
          gioTracking('track', eventName, {
            // isMkt: isMkt,
            // isNewLR: isNewLR,
            // isNewLRMkt: isNewLR,
            isNewLRMkt: isNewLRMkt,
            isAll: isAll,
            sUrl,
            regUrl: location.href,
            isQR:0
          })
        } catch (e) {
          console.error(e)
        }

        if (window._hmt) {
          window._hmt.push([
            "_trackEvent",
            "Login",
            hmsrTxt,
            response.isNewUser,
            1,
          ]);
        }
      } catch (e) {
        console.error(e);
      }
      if (response.accessToken) {
        this.$loading.show();
        const result = await api.user.getUserInfo(response.accessToken);
        this.$loading.hide();
        if (result && result.data && result.data.localRewardToken) {
          this.localRewardToken = result.data.localRewardToken;
        }
        this.isRegisterSuccess = true;
      }
    },
    getSendSmsCodeText() {
      if (this.smsCodeCountDown <= 0) {
        return "发送验证码";
      } else {
        return `验证码(${this.smsCodeCountDown}s)`;
      }
    },
    goToLocalReward() {
      location.href = this.localRewardUrl;
    },
  },
  computed: {
    sessionKey() {
      return this.$store.state.page.sessionKey;
    },
    pageHeight() {
      return {
        height: window.innerHeight + "px",
      };
    },
    localRewardUrl() {
      return `${process.env.VUE_APP_REWARD_URL}/reward?token=${this.localRewardToken}`;
    },
  },
};
</script>

<style lang="less" scoped>
/****
 黄色：#f0b012
 蓝色：#000d57
****/
.item-tips {
  width: 300px;
  margin: 5px auto;
  color: #e36a59;
  font-size: 14px;
  margin-left: 27px;
}
.item-tips a {
  color: #e36a59;
  display: inline-block;
  width: 84px;
  height: 20px;
  border-bottom: 1px solid #e36a59;
}

.view-login {
  position: relative;
  margin-top: -50px;
}

.view-login .mt15 {
  margin-top: 15px;
  border: 1px solid #6e7aa8;
  border-radius: 5px;
  /*box-shadow: 0px 0px 15px 0px rgba(49, 49, 49, 0.09);*/
}
.view-login .mt15:first-child {
  margin-top: 0;
  background: #fff;
}
.view-login .mt10 {
  margin-top: 10px;
}

.login-title {
  position: relative;
  /*margin-top: 40px;*/
  text-align: center;
  color: #fff;
  
  letter-spacing: 0;
}

.login-title .login-title-content {
  font-size: 25px;
  margin-bottom: 20px;
}

.login-title-tips {
  margin: 15px 37.5px 0px 37.5px;
  font-size: 12px;
  text-align: left;
  color: #000;
}

/**** 注册页面/注册成功页面****/
.loginCon {
  padding-bottom: 34px;
  margin-top: -24px;
}

.loginButton {
  /*background-image: -webkit-gradient(linear, right top, left top, from(#FAD961), to(#FEBC10));
	background-image: -webkit-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
	background-image: -moz-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
	background-image: -o-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
	background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);*/
  border-radius: 5px;
  
  font-size: 16px;
  color: #454545;
  letter-spacing: 2.5px;
  text-align: center;
  margin: 0 10px;
  height: 50px;
  line-height: 50px;
}

.view-login .noborder {
  border: none !important;
}

.page-content {
  -webkit-background-size: 100% 100%;
  -o-background-size: 100% 100%;
  background-size: 100%;
  position: relative;
  background-color: #fff;
  text-align: center;
}

.view-login nav.home-bar-nav {
  background-color: #061556;
}

.view-login .login-menu {
  overflow: hidden;
  margin-top: 34px;
  margin-left: 10px;
  margin-right: 10px;
}

.view-login .login-menu .item-menu {
  width: 100%;
  float: left;
  background-color: rgba(228, 228, 228, 0.2);
  color: #f0af11;
  font-size: 13px;
  height: 34px;
  line-height: 34px;
  text-align: center;
}

.view-login .login-menu .item-menu.active {
  background-color: #061556;
  color: #fff;
}

.view-login .card {
  margin-top: 0;
  border-radius: 0;
}

.view-login .list-block {
  margin: 0;
}

.view-login .list-block ul::before,
.view-register .list-block ul::after {
  height: 0;
}

.item-content {
  margin: 0 37.5px;
  position: relative;
}

.view-login .item-inner {
  position: relative;
  width: 100%;
  height: 50px;
  overflow: hidden;
}

.view-login .item-inner::after {
  background-color: #fff !important;
}

.view-login .item-media {
}

.item-input-title {
  color: #333;
  font-size: 14px;
  line-height: 1;
  position: absolute;
  top: 50%;
  left: 0px;
  padding-left: 14px;
  width: 90px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}

.item-callingCode {
  position: relative;
  display: inline-block;
  float: left;
}

.login-txt {
  font-size: 12px;
}

.login-img {
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 50%;
  background: #febc10;
  color: #333;
  text-align: center;
  line-height: 16px;
  margin-right: 4px;
}

.login-alink.login-title-tips {
  margin-top: 8px;
  color: #000;
}

.memberLink.external {
  color: #febc10;
}
.privacyLink.external {
  color: #febc10;
}

.view-login .item-input {
  margin-bottom: 0;
}

.view-login .item-input input {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
  border-width: 0px;
  outline: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-appearance: none;
  display: block;
  width: 100%;
  height: 50px;
  text-align: left;
  padding-left: 95px;
  padding-top: 15px;
  padding-bottom: 15px;
  font-size: 14px;
  color: #333;
  line-height: 20px;
}

.view-login .item-input input::-webkit-input-placeholder {
  
  font-size: 14px;
  color: #b1b1b1;
  letter-spacing: 0;
}

.view-login .i1_pic {
  height: 32px;
}

.view-login .send_btn {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  position: absolute;
  right: 15px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}

.view-login .login-phone .login-remindTxt {
  margin-top: 28px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}

.view-login .login-phone .login-remindTxt span {
  color: #f0af11;
}

.view-login .login-phone .loginPromot,
.view-login .login-user .loginPromot {
  padding: 20px 20px 20px;
  text-align: center;
  font-size: 12px;
  color: #fff;
}

.view-login .login-user .login-remindTxt {
  margin-top: 110px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}

.view-login .login-user .login-remindTxt span {
  color: #f0af11;
}

.check--login .checkbox--img {
  display: inline-block;
  vertical-align: middle;
}

.check--login .checkbox--img img {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.check--login span {
  margin-left: 4px;
  vertical-align: middle;
  color: #fff;
  font-size: 12px;
}

.sin_container {
  margin: 0 37.5px;
  font-size: 12px;
}

.loginCon .input__top {
  margin: 10px;
}

.sin_container a {
  color: #edb000;
}

.sin_container .input__top img {
  width: 14px;
  height: 14px;
  cursor: pointer;
  vertical-align: middle;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isAgreePushMsg.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isAgreePushMsg.active img:nth-child(2) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isAgreePrivacy.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isAgreePrivacy.active img:nth-child(2) {
  display: none;
}

/*注册会员*/
.sin_container .input__top.isRegisterMember img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isRegisterMember img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isRegisterMember.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isRegisterMember.active img:nth-child(2) {
  display: none;
}

.sin_container span {
  margin-left: 4px;
  vertical-align: middle;
  color: #fff;
}

.sin_container .input__top {
  margin: 10px;
}

.bookingSmile {
  font-size: 15px;
  text-align: center;
  margin-top: 15px;
  color: #fff;
}

.bookingSmile img {
  height: 20px;
  vertical-align: middle;
}

.callingCode {
  max-width: 114px;
  background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg)
    no-repeat right transparent;
  border: 0;
  -moz-appearance: none;
  -webkit-appearance: none;
  text-overflow: ellipsis;
  padding-right: 16px;
  overflow: hidden;
  white-space: nowrap;
}

.callingCode-css {
  opacity: 0;
  position: absolute;
  left: 0;
  top: -18px;
  height: 50px;
  width: 80px;
}

#phone {
  width: 150px;
  display: inline-block;
  padding-top: 15px;
  padding-bottom: 16px;
  -moz-appearance: none;
  appearance: none;
  -webkit-appearance: none;
  border: none;
  float: left;
  margin-left: 4px;
  padding-left: 0px;
  font-size: 14px;
  line-height: 20px;
}

.view-login #vcode {
  position: absolute;
  top: 13px;
  right: 10px;
}
.page-bg {
  width: 100%;
  height: 492px;
  position: relative;
  text-align: center;
}

.page-banner .swiper-container {
  padding-bottom: 0px;
}

.page-banner .swiper-container img {
  width: 100%;
}

.page-bg .page-title-image {
  position: absolute;
  z-index: 1;
  width: 292px;
  left: 41px;
  top: 86px;
}

.rule {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 1;
}
.rule span {
  color: #fff;
  font-size: 12px;
  margin-left: 3px;
}
.rule img {
  width: 12px;
  vertical-align: middle;
}
.home_logo {
  width: 32px;
  position: absolute;
  top: 12px;
  z-index: 1;
  left: 172px;
}
.yourfriend {
  font-size: 18px;
  color: #fff;
  line-height: 1.1;
  position: absolute;
  top: 57px;
  z-index: 1;
  width: 100%;
  text-align: center;
}
.newText {
  position: absolute;
  bottom: 119px;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.3;
  text-shadow: 0px 0px 6px rgba(44, 44, 44, 0.6);
  padding-right: 40px;
  letter-spacing: 1px;
  z-index: 1;
}

.page-content .page-form {
  position: relative;
  top: -84px;
  z-index: 1;
}

.view-login .loginButton {
  font-size: 16px;
  color: #4c3a0e;
  font-weight: bold;
  border: 0;
  /*background-image: -moz-linear-gradient( 0deg, rgb(248,70,35) 0%, rgb(222,21,68) 100%);
	background-image: -webkit-linear-gradient( 0deg, rgb(248,70,35) 0%, rgb(222,21,68) 100%);
	background-image: -ms-linear-gradient( 0deg, rgb(248,70,35) 0%, rgb(222,21,68) 100%);
	background: url(https://resource.rcclchina.com.cn/memberCenter/bj1.png) no-repeat;
	background-size: 100%;*/
  /*box-shadow: 20.569px 24.513px 29px 0px rgba(152, 45, 70, 0.28);*/
}
.view-login .loginButton img {
  max-width: 100%;
}
.login-title-tips > img {
  /*width: 14px;*/
  height: 14px;
  vertical-align: middle;
  margin-right: 7px;
  margin-top: 2px;
}
.login-txt {
  display: flex;
}
.login-txt > span {
  display: block;
}
.footer-nav {
  display: none;
}
.footLogo {
  width: 136px;
}
.footTxt {
  display: block;
  margin: 15px 37.5px 0px 37.5px;
  font-size: 10px;
  font-weight: bold;
  color: #333;
  text-align: center;
  line-height: 1.5;
  -webkit-transform: scale(0.833);
  -webkit-text-size-adjust: none;
}
.logo2 {
  width: 36px;

  margin-top: 25px;
}
div.page-success {
  background: url("https://resource.rcclchina.com.cn/userCenter/mb-mycoupon.png")
    top center no-repeat;
  background-size: 100%;
}
.s-txt {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #000861;
  letter-spacing: 1px;
  line-height: 30px;
  margin-top: 14px;
}
.s-price {
  /*font-size: 40px;*/
  font-weight: bold;
  /*background: linear-gradient(to right, #f84623, #de1544);*/
  /*-webkit-background-clip: text;*/
  color: transparent;
  margin-bottom: 13px;
  margin-top: 12px;
  line-height: 1;
}
.s-price img {
  padding-left: 25px;
  padding-right: 25px;
  max-width: 100%;
  max-height: 34px;
}
.s-line {
  width: 74px;
  height: 1px;
  background-color: #000861;
  margin: 0 auto;
  margin-bottom: 7px;
}
.s-text {
  padding: 0px 40px;
  font-size: 14px;
  line-height: 1.5;
  color: #000;
  text-align: left;
  margin-bottom: 150px;
}
.s-comm {
  width: 300px;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
  line-height: 50px;
  letter-spacing: 1px;
}
.s-order {
  background-image: -moz-linear-gradient(
    0deg,
    rgb(248, 70, 35) 0%,
    rgb(222, 21, 68) 100%
  );
  background-image: -webkit-linear-gradient(
    0deg,
    rgb(248, 70, 35) 0%,
    rgb(222, 21, 68) 100%
  );
  background-image: -ms-linear-gradient(
    0deg,
    rgb(248, 70, 35) 0%,
    rgb(222, 21, 68) 100%
  );
  background: url(https://resource.rcclchina.com.cn/memberCenter/bj1.png)
    no-repeat;
  background-size: 100%;
  color: #4c3a0e;
}
.s-myCoupon {
  background-color: #25388a;
}
/*注册会员*/
.login-title-tips.isRegisterMember img:nth-child(1) {
  display: none;
}

.login-title-tips.isRegisterMember img:nth-child(2) {
  display: inline-block;
}

.login-title-tips.isRegisterMember.active img:nth-child(1) {
  display: inline-block;
}

.login-title-tips.isRegisterMember.active img:nth-child(2) {
  display: none;
}
/**/
.login-title-tips.isAgreePrivacy img:nth-child(1) {
  display: none;
}

.login-title-tips.isAgreePrivacy img:nth-child(2) {
  display: inline-block;
}

.login-title-tips.isAgreePrivacy.active img:nth-child(1) {
  display: inline-block;
}

.login-title-tips.isAgreePrivacy.active img:nth-child(2) {
  display: none;
}
/***/
/**/
.login-title-tips.isAgreePushMsg img:nth-child(1) {
  display: none;
}

.login-title-tips.isAgreePushMsg img:nth-child(2) {
  display: inline-block;
}

.login-title-tips.isAgreePushMsg.active img:nth-child(1) {
  display: inline-block;
}

.login-title-tips.isAgreePushMsg.active img:nth-child(2) {
  display: none;
}
</style>

<style lang="less">
.view-login {
	.verification-popup {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 111;
    .verification-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.7);
    }
    .verification-content {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 300px;
      height: 130px;
      padding-top: 24px;
      background-color: #fff;
      border-radius: 5px;
      text-align: center;
      #verificationMain {
        margin-top: 15px;
        position: relative;
        .nc_wrapper {
          width: 220px;
          margin: auto;
        }
        .nc_scale span {
          height: 34px;
        }
      }
    }
  }
}
.login-vip {
  margin: 0 37.5px;
  font-size: 13px;
  text-align: left;
  border: none !important;
  & .vip-title {
    font-weight: bold;
    padding: 0;
    margin: 0;
  }
  & .vip-content {
    margin: 0;
    padding: 0;
  }
  & .vip-content li {
    margin-top: 3px;
  }
}
</style>
